import { Link } from 'react-router-dom';

// Определяем интерфейс для Стихотворения
interface Poem {
  id: number;
  title: string;
}


// Массив стихов
const poems: Poem[] = [
  { id: 1, title: "Мои стихи" },
  { id: 2, title: "Ангел" },
  { id: 3, title: "Ангел грешный, ангел мой…" },
  { id: 4, title: "Расскажи мне, ангел тьмы…" },
  { id: 5, title: "Ты поведай мне, демон, про любовь и про верность." },
  { id: 6, title: "Ангел чёрный, ангел бездны…" },
  { id: 7, title: "Ангел грешный, ангел падший…" },
  { id: 8, title: "Ангел чистый, непорочный!.." },
  { id: 9, title: "Он когда-то был ангелом…" },
  { id: 10, title: "Влюблённый ангел" },
  { id: 11, title: "Ангел ночи, ангел смерти!.." },
  { id: 12, title: "Олеся" },
  { id: 13, title: "Дракула" },
  { id: 14, title: "Оплавляются души…" },
  { id: 15, title: "Принцессы да сказки…" },
  { id: 16, title: "Кошка" },
  { id: 17, title: "Ты пока ещё снишься…" },
  { id: 18, title: "Разлетается в душе — снег…" },
  { id: 19, title: "Не вспоминай!.." },
  { id: 20, title: "И до сих пор в душе твой свет…" },
  { id: 21, title: "Всё это было, как вчера…" },
  { id: 22, title: "Забываются сны…" },
  { id: 23, title: "Расставание" },
  { id: 24, title: "Я, наверно, не вернусь…" },
  { id: 25, title: "Словно раненые птицы…" },
  { id: 26, title: "Ты прощай, прощай, прощай…" },
  { id: 27, title: "Ещё не умерла любовь!.." },
  { id: 28, title: "Твои губы и очи…" },
  { id: 29, title: "Душа жаждет вернуться…" },
  { id: 30, title: "Мы видим только маски…" },
  { id: 31, title: "Сохранить — трудно…" },
  { id: 32, title: "Боль от измены…" },
  { id: 33, title: "Может, изредка всё-таки и — вспоминаешь?.." },
  { id: 34, title: "Ты мне снишься хоть реже…" },
  { id: 35, title: "Как часто любим мы друг друга…" },
  { id: 36, title: "Прощание с любовью" },
  { id: 37, title: "Ты вспоминаешься порою…" },
  { id: 38, title: "Всего я достигну…" },
  { id: 39, title: "Когда я в этом мире все дела…" },
  { id: 40, title: "Любовь нарывом набухает…" },
  { id: 41, title: "Воспоминанья — только пригубить!.." },
  { id: 42, title: "Я уйду в никуда на рассвете…" },
  { id: 43, title: "Ты снилась мне всегда…" },
  { id: 44, title: "Ей" },
  { id: 45, title: "Неотправленное письмо" },
  { id: 46, title: "Милый мой, дорогой!.." },
  { id: 47, title: "Багдад, Шехерезада…" },
  { id: 48, title: "Искушения грёзы…" },
  { id: 49, title: "Ты умерла лет сто назад…" },
  { id: 50, title: "Ты приснилась мне снова…" },
  { id: 51, title: "Как мотылёк на огонёк…" },
  { id: 52, title: "Уходя — уходи…" },
  { id: 53, title: "Грустная история" },
  { id: 54, title: "Позади лишь долги…" },
  { id: 55, title: "Любовь — игрушка…" },
  { id: 56, title: "Нас женщины ушами любят…" },
  { id: 57, title: "Эдем" },
  { id: 58, title: "Любишь — не осудишь…" },
  { id: 59, title: "От любви до разлуки…" },
  { id: 60, title: "Встреча" },
  { id: 61, title: "Смерть и любовь…" },
  { id: 62, title: "На перепутье жизненных дорог…" },
  { id: 63, title: "Я когда-нибудь умру…" },
  { id: 64, title: "Жизнь, конечно, не мёд…" },
  { id: 65, title: "Здесь сирины редки…" },
  { id: 66, title: "Что же, что же, что же!.." },
  { id: 67, title: "Мне мерещится бездна…" },
  { id: 68, title: "Порою чудные картины…" },
  { id: 69, title: "Я взорвал все мосты…" },
  { id: 70, title: "Когда-нибудь, но встанет рассвет…" },
  { id: 71, title: "А ведь было, мечталось!.." },
  { id: 72, title: "Я б поставил последний крест…" },
  { id: 73, title: "Я не терплю фраз!.." },
  { id: 74, title: "Пустоты — страх…" },
  { id: 75, title: "Всё как-то не так…" },
  { id: 76, title: "Одних комедий череда…" },
  { id: 77, title: "Рвётся душа, как шёлк…" },
  { id: 78, title: "Я убегал в никуда…" },
  { id: 79, title: "Любая красота рождается из пены…" },
  { id: 80, title: "Когда пороки так мерзки…" },
  { id: 81, title: "Дотла!.." },
  { id: 82, title: "Вьюга плачет, вьюга злится!.." },
  { id: 83, title: "Я всё завоюю и всё потеряю!.." },
  { id: 84, title: "Их уже не хватало в шеренгах по восемь…" },
  { id: 85, title: "Меняются ритмы, меняются темы…" },
  { id: 86, title: "Мы все предавали, мы все оступались…" },
  { id: 87, title: "Мы живём в двух мирах…" },
  { id: 88, title: "Заклятие Демона" },
  { id: 89, title: "Антихрист" },
  { id: 90, title: "Люцифер Светоносец" },
  { id: 91, title: "Каждый демон — ангел бывший…" },
  { id: 92, title: "Встреча Демона с Ангелом" },
  { id: 93, title: "Пробуждение Демона" },
  { id: 94, title: "Проклятие Демона" },
  { id: 95, title: "Демон" },
  { id: 96, title: "Демон-2" },
  { id: 97, title: "Демон-3" },
  { id: 98, title: "Демон-4" },
  { id: 99, title: "Армагеддон" },
  { id: 100, title: "Страшный суд" },
  { id: 101, title: "Разговор Сатаны с Архангелами" },
  { id: 102, title: "Сатана" },
  { id: 103, title: "Пробуждение Сатаны" },
  { id: 104, title: "Перечитывая Данта" },
  { id: 105, title: "Перечитывая Данта 2" },
  { id: 106, title: "Одиссей" },
  { id: 107, title: "Ганнибал" },
  { id: 108, title: "Медуза" },
  { id: 109, title: "Клио" },
  { id: 110, title: "Кассандра" },
  { id: 111, title: "Аргонавты" },
  { id: 112, title: "Андромеда" },
  { id: 113, title: "Джульетта" },
  { id: 114, title: "Орфей" },
  { id: 115, title: "Орфей-2" },
  { id: 116, title: "Венера" },
  { id: 117, title: "Дон Жуан" },
  { id: 118, title: "Казанова" },
  { id: 119, title: "Суд Париса" },
  { id: 120, title: "Король Лир" },
  { id: 121, title: "Дон Кихот" },
  { id: 122, title: "Из цикла Собор Парижской Богоматери, Цыганка" },
  { id: 123, title: "Из цикла Собор Парижской Богоматери, Священник" },
  { id: 124, title: "Из цикла Собор Парижской Богоматери, Квазимодо" },
  { id: 125, title: "Из цикла Собор Парижской Богоматери, Эсмеральда" },
  { id: 126, title: "Гамлет" },
  { id: 127, title: "Гамлет-2" },
  { id: 128, title: "Гамлет-3" },
  { id: 129, title: "Гамлет-4" },
  { id: 130, title: "Гамлет-5" },
  { id: 131, title: "Гамлет-6" },
  { id: 132, title: "Цикл Гамлет. Заключение" },
  { id: 133, title: "Из цикла Гамлет, Не в том вопрос…" },
  { id: 134, title: "Из цикла Гамлет, Бедный Йорик" },
  { id: 135, title: "Снова о Гамлете" },
  { id: 136, title: "Тайна Пушкина" },
  { id: 137, title: "Подражание Пушкину" },
  { id: 138, title: "Посвящение Пушкину" },
  { id: 139, title: "Поэзия России…" },
  { id: 140, title: "Муза снова упорхнула…" },
  { id: 141, title: "Где же эта Муза?.." },
  { id: 142, title: "Муза приходит ночью…" },
  { id: 143, title: "Чего-то хочется порой…" },
  { id: 144, title: "Флирт с Музой" },
  { id: 145, title: "Колготки иль рейтузы натягивает Муза…" },
  { id: 146, title: "Ах, с музой у меня сейчас роман!.." },
  { id: 147, title: "Ах, слова бы найти!.." },
  { id: 148, title: "Стихи — не пишутся порой…" },
  { id: 149, title: "Проклятие творчества" },
  { id: 150, title: "Фея вьётся вкруг цветочка…" },
  { id: 151, title: "Маргарита" },
  { id: 152, title: "Двенадцать стульев" },
  { id: 153, title: "Когда беда устаёт к утру…" },
  { id: 154, title: "Искушенье души — испытанье боязнью…" },
  { id: 155, title: "Снова ветер…" },
  { id: 156, title: "Кому — небеса, а кому — смола…" },
  { id: 157, title: "Женщина" },
  { id: 158, title: "В счастье не верится, горе пугает…" },
  { id: 159, title: "Глаза прикроешь лишь — и вновь…" },
  { id: 160, title: "Мечты сгорают, как дрова…" },
  { id: 161, title: "Уходить надо вовремя…" },
  { id: 162, title: "Дождик каплет кап-кап-кап!.." },
  { id: 163, title: "Стихи — не просто так!.." },
  { id: 164, title: "Я будто слышу отголоски…" },
  { id: 165, title: "Мне представляется порой…" },
  { id: 166, title: "Я видел ад…" },
  { id: 167, title: "Я из древнего племени…" },
  { id: 168, title: "Сквозь вечности время…" },
  { id: 169, title: "Нет никаких других миров…" },
  { id: 170, title: "Сквозь бесконечные миры…" },
  { id: 171, title: "Душа — пуста…" },
  { id: 172, title: "Умереть бы, уснуть!.." },
  { id: 173, title: "Стоя у последней черты…" },
  { id: 174, title: "Если рвать…" },
  { id: 175, title: "Нет ни жизни, ни смерти…" },
  { id: 176, title: "Осенние деревья" },
  { id: 177, title: "Хочется про любовь…" },
  { id: 178, title: "Ни черта нет на свете!.." },
  { id: 179, title: "Что счастья нет на свете — это ясно…" },
  { id: 180, title: "Судьба, судьба!.." },
  { id: 181, title: "Где сомненье, где вера?.." },
  { id: 182, title: "Убеждать — бесполезно…" },
  { id: 183, title: "В бездну вместе…" },
  { id: 184, title: "Ветер вечности ломится в окна…" },
  { id: 185, title: "Нас вначале качали на ландышах феи!.." },
  { id: 186, title: "Да, путь пугает новый…" },
  { id: 187, title: "Пиковая дама" },
  { id: 188, title: "Я порой ошибаюсь…" },
  { id: 189, title: "Обрывается сердца стук — стоном…" },
  { id: 190, title: "Ад — это назад…" },
  { id: 191, title: "Короткие мысли — короткие строчки…" },
  { id: 192, title: "От надежды к надежде…" },
  { id: 193, title: "Текут слёзы…" },
  { id: 194, title: "Привыкаешь ко всему…" },
  { id: 195, title: "Веры сор под ногами…" },
  { id: 196, title: "Никому не верь!.." },
  { id: 197, title: "Не бойся, не проси, не верь…" },
  { id: 198, title: "Мы из юности — маршем!.." },
  { id: 199, title: "Вот интересно, жил я, жил…" },
  { id: 200, title: "Мы не верим друг другу…" },
  { id: 201, title: "Не верь ни в сказки, ни в мечты…" },
  { id: 202, title: "Ты не плачь, не грусти…" },
  { id: 203, title: "Судьба находит щели…" },
  { id: 204, title: "Герои гибнут…" },
  { id: 205, title: "Судьба мудрее нас…" },
  { id: 206, title: "Нет ни ада, ни рая…" },
  { id: 207, title: "Сбываются сказки…" },
  { id: 208, title: "Я, конечно, кончу плохо…" },
  { id: 209, title: "Позади всё — о-хо-хо-хо!.." },
  { id: 210, title: "Всех ангелов — к чёрту!.." },
  { id: 211, title: "Не жалею, не зову, не плачу…" },
  { id: 212, title: "Что-то случается, что-то сбывается…" },
  { id: 213, title: "Всё, конечно, случится…" },
  { id: 214, title: "Я всё могу представить…" },
  { id: 215, title: "Слепых случайностей порой…" },
  { id: 216, title: "Призраки прошлого…" },
  { id: 217, title: "Мне тоска поскулила…" },
  { id: 218, title: "Может быть, уж пора?.." },
  { id: 219, title: "Испугаться бы, что ли!.." },
  { id: 220, title: "Ничего не волнует…" },
  { id: 221, title: "Плачет дождик за окном…" },
  { id: 222, title: "Скучно, вяло…" },
  { id: 223, title: "Уныние точит…" },
  { id: 224, title: "То ли влево, то ли вправо…" },
  { id: 225, title: "Любовь — подделка!.." },
  { id: 226, title: "Слово — финкой под душу…" },
  { id: 227, title: "Я, наверно, дошёл до предела…" },
  { id: 228, title: "Всадник бледный мчится, мчится!.." },
  { id: 229, title: "Неосторожная встреча с пророком" },
  { id: 230, title: "Аутодафе" },
  { id: 231, title: "Как хочется счастья!.." },
  { id: 232, title: "Я пришёл бы…" },
  { id: 233, title: "Нет ни мистики, ни тайны…" },
  { id: 234, title: "Сполохи вечности душу тревожат…" },
  { id: 235, title: "Бесконечность миров…" },
  { id: 236, title: "Мужчины баба хоть глупее…" },
  { id: 237, title: "Все люди на свете…" },
  { id: 238, title: "В мире ты — ничей…" },
  { id: 239, title: "Мы когда-то мечтали!.." },
  { id: 240, title: "Нам страшно без веры…" },
  { id: 241, title: "Дождик всхлипывает вяло…" },
  { id: 242, title: "Дни, как капли, один на другой…" },
  { id: 243, title: "Человек — странен…" },
  { id: 244, title: "Дождик плачет неутешно…" },
  { id: 245, title: "Грустно, скучно и тоскливо…" },
  { id: 246, title: "От вечности один шаг…" },
  { id: 247, title: "Прошедшее — смутно…" },
  { id: 248, title: "Осени, осени, осени, осени серость!.." },
  { id: 249, title: "Жизнь устроена хитро…" },
  { id: 250, title: "Дождик сумрачно бормочет…" },
  { id: 251, title: "Мы когда-то встречались…" },
  { id: 252, title: "Я позабыл твои глаза, твою походку…" },
  { id: 253, title: "Коварство близких тем больнее…" },
  { id: 254, title: "Я не жалею ни о ком и никогда…" },
  { id: 255, title: "Мне хочется верить!.." },
  { id: 256, title: "Ах, карты масть!.." },
  { id: 257, title: "Сума да тюрьма…" },
  { id: 258, title: "Как-то раз беда от скуки…" },
  { id: 259, title: "Гой вы, други мои, други!.." },
  { id: 260, title: "Эх, пожить бы, поблажить!.." },
  { id: 261, title: "Судьба кидает спиннинг…" },
  { id: 262, title: "Душа, как зуб, болит…" },
  { id: 263, title: "Убежать бы в никуда!.." },
  { id: 264, title: "Беда — через край!.." },
  { id: 265, title: "Я, как Лойола из лойол…" },
  { id: 266, title: "Арлекино" },
  { id: 267, title: "Мне кажется, кажется, кажется, кажется…" },
  { id: 268, title: "С судьбой играя, плутовать…" },
  { id: 269, title: "Когда тоска подступает вплотную…" },
  { id: 270, title: "Мне демон знакомый шепнул по секрету…" },
  { id: 271, title: "Вера, Надежда, Любовь" },
  { id: 272, title: "То ли прощание, то ли прощение!.." },
  { id: 273, title: "И гарпии тоски…" },
  { id: 274, title: "Одиночества груз…" },
  { id: 275, title: "У счастья завтра нет…" },
  { id: 276, title: "Есть люди — из меди…" },
  { id: 277, title: "Когда б ни гордости безумье…" },
  { id: 278, title: "Всё — плохо!.." },
  { id: 279, title: "Искушеньями — сыт!.." },
  { id: 280, title: "Я прошёл через ад…" },
  { id: 281, title: "Судьба словно клинок из меня выковывает!.." },
  { id: 282, title: "Если завтра — хоть как-то…" },
  { id: 283, title: "Я — последний боец…" },
  { id: 284, title: "Ты куда-куда-куда?.." },
  { id: 285, title: "Судьба орёт…" },
  { id: 286, title: "Похоронный звон — над надеждами…" },
  { id: 287, title: "Эх, за шиворот судьбу б ухватить!.." },
  { id: 288, title: "Бросить всё бы, да уйти…" },
  { id: 289, title: "Судьба огнивом бьёт…" },
  { id: 290, title: "Рай. Цербера лай…" },
  { id: 291, title: "Жизнь — смешная штука…" },
  { id: 292, title: "Ступая в ада новый круг…" },
  { id: 293, title: "Вы, конечно, и дальше живите…" },
  { id: 294, title: "Жизнь моя — то ли сказка…" },
  { id: 295, title: "Всё начинается сначала…" },
  { id: 296, title: "Грядущего рокот…" },
  { id: 297, title: "Гладиатором в Риме…" },
  { id: 298, title: "Всё меняет время…" },
  { id: 299, title: "Всё опять затянуло…" },
  { id: 300, title: "Умирая - умирай!.." },
  { id: 301, title: "Что же там, за горизонтом?.." },
  { id: 302, title: "Сердце рвётся на части…" },
  { id: 303, title: "Безнадёжности бездна…" },
  { id: 304, title: "Где друзья?.." },
  { id: 305, title: "Я — последний живой…" },
  { id: 306, title: "Лучшие гибнут первыми…" },
  { id: 307, title: "Красивый фильм…" },
  { id: 308, title: "Распад, распад, распад, распад!.." },
  { id: 309, title: "Счастия не поймать…" },
  { id: 310, title: "И любовь не спасает!.." },
  { id: 311, title: "Слова — как птички…" },
  { id: 312, title: "Ни прощенья, ни мести!.." },
  { id: 313, title: "Не надо ни черта!" },
  { id: 314, title: "Лодочка плывёт, на волнах качается…" },
  { id: 315, title: "Вот интересно…" },
  { id: 316, title: "Вяло дождь ворчит…" },
  { id: 317, title: "Ночная гроза" },
  { id: 318, title: "Наши лучшие годы…" },
  { id: 319, title: "Мы создаём себе кумиров…" },
  { id: 320, title: "Нет случайностей в мире…" },
  { id: 321, title: "Тоска рядится в любые маски…" },
  { id: 322, title: "Прожитых лет — груз…" },
  { id: 323, title: "Когда мне было тяжело…" },
  { id: 324, title: "Тоска всё туже…" },
  { id: 325, title: "Эх, удача, удача!.." },
  { id: 326, title: "Беда — уже по грудь…" },
  { id: 327, title: "И с размаху наотмашь!.." },
  { id: 328, title: "Депрессии холод…" },
  { id: 329, title: "Холода да слякоть!.." },
  { id: 330, title: "Тоска — тисками!.." },
  { id: 331, title: "Всё не так, не так, не так!.." },
  { id: 332, title: "Мы тлеем, как свечки…" },
  { id: 333, title: "Мечталось, хотелось!.." },
  { id: 334, title: "Чья душа моя?.." },
  { id: 335, title: "Мы верим в сказки…" },
  { id: 336, title: "С ухмылкою недоброю…" },
  { id: 337, title: "Когда первый раз предаёшь…" },
  { id: 338, title: "Мы не знаем ответов…" },
  { id: 339, title: "Последние месяцы, дни и недели…" },
  { id: 340, title: "Время катит, катит, катит!.." },
  { id: 341, title: "Прошлого — нет…" },
  { id: 342, title: "Мы все одиноки…" },
  { id: 343, title: "Судьба играет, как кошка с мышкой…" },
  { id: 344, title: "Жизнь — шахматы, не кости!.." },
  { id: 345, title: "Моя с фортуною любовь…" },
  { id: 346, title: "Когда-то мечталось…" },
  { id: 347, title: "Впереди — мрак…" },
  { id: 348, title: "Осени хмурость…" },
  { id: 349, title: "Мне постоянно снится сон…" },
  { id: 350, title: "Всё рушится, рушится, рушится!.." },
  { id: 351, title: "Галактик тихий свет…" },
  { id: 352, title: "Сквозь столетья и века…" },
  { id: 353, title: "Научиться б предавать!.." },
  { id: 354, title: "Как железо в кислоте…" },
  { id: 355, title: "Тоска воняет и чадит…" },
  { id: 356, title: "Победа — пораженье…" },
  { id: 357, title: "Ночь, ночь, ночь!.." },
  { id: 358, title: "И день наступит!.." },
  { id: 359, title: "Что-то сбудется, что-то станется…" },
  { id: 360, title: "Жить? Не трудно, а — нудно…" },
  { id: 361, title: "Сначала? — поздно!" },
  { id: 362, title: "Что там, впереди?.." },
  { id: 363, title: "Я помню звёзд прозрачный свет…" },
  { id: 364, title: "От волненья дыша едва…" },
  { id: 365, title: "Жизнь — скучная штука…" },
  { id: 366, title: "Женщинам" },
  { id: 367, title: "Шебуршится дождик на крыше…" },
  { id: 368, title: "Разговор со смертью" },
  { id: 369, title: "Мы куда-то стремимся!.." },
  { id: 370, title: "Народ всё — в рай…" },
  { id: 371, title: "Что там, вдали, свет?.." },
  { id: 372, title: "Я, конечно, бы смог…" },
  { id: 373, title: "Спрятаться б, скрыться!.." },
  { id: 374, title: "Нет, нельзя отрекаться!.." },
  { id: 375, title: "Упрекать, обвинять!.." },
  { id: 376, title: "Бороться — трудно, смириться — просто…" },
  { id: 377, title: "Что-то страшно, что-то жутко!.." },
  { id: 378, title: "Падает на сердце снег…" },
  { id: 379, title: "Звёзды царят…" },
  { id: 380, title: "Жизнь до смешного коротка…" },
  { id: 381, title: "Активной жизни — ну, пусть полвека…" },
  { id: 382, title: "В вечном страхе…" },
  { id: 383, title: "Жизнь — подлая сука…" },
  { id: 384, title: "Да, путь мой во мраке…" },
  { id: 385, title: "Бесы злобны, бесы прытки…" },
  { id: 386, title: "Моя судьба…" },
  { id: 387, title: "Люди живут…" },
  { id: 388, title: "Всё же жутко — умирать…" },
  { id: 389, title: "Жизнь какая-то пустая…" },
  { id: 390, title: "Мы верим в сказки…" },
  { id: 391, title: "Реальность постыла и осточертела…" },
  { id: 392, title: "Устал от грёз!.." },
  { id: 393, title: "Жизнь берёт и берёт!.." },
  { id: 394, title: "Действительность — глупа…" },
  { id: 395, title: "Жизнь" },
  { id: 396, title: "Кончается время…" },
  { id: 397, title: "Воспоминание" },
  { id: 398, title: "Жил-жил, не тужил…" },
  { id: 399, title: "Я вернулся из ада…" },
  { id: 400, title: "Мы живём в суете…" },
  { id: 401, title: "Хочется света…" },
  { id: 402, title: "Утешение" },
  { id: 403, title: "Я, конечно, не бог…" },
  { id: 404, title: "Вся жизнь — какой-то полусон…" },
  { id: 405, title: "Нам никогда уже не стать никем…" },
  { id: 406, title: "Мы книгу жизни не читаем…" },
  { id: 407, title: "Зрелость от юности чем отличается?.." },
  { id: 408, title: "Мы просто детишки…" },
  { id: 409, title: "Сказка — ложь, а жизнь — вдвойне!.." },
  { id: 410, title: "Жизнь течёт как вода…" },
  { id: 411, title: "Моя жизнь" },
  { id: 412, title: "Что-то сбудется…" },
  { id: 413, title: "Недопето-недолюблено!.." },
  { id: 414, title: "Верность — вздор!.." },
  { id: 415, title: "Рая нет…" },
  { id: 416, title: "Рыцарь тьмы или света?.." },
  { id: 417, title: "Всюду скука, скука, скука!.." },
  { id: 418, title: "Я мог бы стать!.." },
  { id: 419, title: "Лихо тихо кружит…" },
  { id: 420, title: "Мы мечтаем о рае…" },
  { id: 421, title: "Эх, от ангелов-то — скука…" },
  { id: 422, title: "Счастья нет, как нет!.." },
  { id: 423, title: "Беда — подружка…" },
  { id: 424, title: "Только боли ушаты…" },
  { id: 425, title: "Всё висит на волоске…" },
  { id: 426, title: "Закончились давно…" },
  { id: 427, title: "Жизнь течёт, как поток…" },
  { id: 428, title: "И до нас жили люди…" },
  { id: 429, title: "Позади — пустота…" },
  { id: 430, title: "Душа — рвётся струною!.." },
  { id: 431, title: "Словно волк в западне…" },
  { id: 432, title: "Усталость, усталость, усталость, усталость…" },
  { id: 433, title: "Пасмурно. Хмуро и серо…" },
  { id: 434, title: "Всё вьюжит и вьюжит…" },
  { id: 435, title: "Бывает — всё худо…" },
  { id: 436, title: "После смерти — ад…" },
  { id: 437, title: "Воспоминания — всё возвращаются…" },
  { id: 438, title: "Смыкаю вежды…" },
  { id: 439, title: "Куда мой путь?.." },
  { id: 440, title: "Я один на свете белом…" },
  { id: 441, title: "Отступать — не научен…" },
  { id: 442, title: "Может, это конец…" },
  { id: 443, title: "Искушения — манят…" },
  { id: 444, title: "В этом долбаном мире…" },
  { id: 445, title: "Уже до упора!.." },
  { id: 446, title: "Я умираю и возрождаюсь…" },
  { id: 447, title: "Мы в юности рвёмся!.." },
  { id: 448, title: "Сплошные тучи…" },
  { id: 449, title: "Ничего нет!.." },
  { id: 450, title: "Если жизнь мою полистать…" },
  { id: 451, title: "Сердце ноет — горе чует…" },
  { id: 452, title: "Мы сиры, убоги…" },
  { id: 453, title: "Не было — ничегошеньки!.." },
  { id: 454, title: "Ты не оглядывайся, нет!.." },
  { id: 455, title: "Жизнь моя не течёт…" },
  { id: 456, title: "Впереди — лишь туман…" },
  { id: 457, title: "Дразнит подлая надежда…" },
  { id: 458, title: "Как всё начиналось!.." },
  { id: 459, title: "Меня — предавали…" },
  { id: 460, title: "Всё рушится опять…" },
  { id: 461, title: "Моя жизнь — это бред!.." },
  { id: 462, title: "Мы рвёмся в бой!.." },
  { id: 463, title: "Чёт — нечёт…" },
  { id: 464, title: "Тоска сосёт…" },
  { id: 465, title: "Вроде, устоялось…" },
  { id: 466, title: "Я когда-то любил…" },
  { id: 467, title: "Из цикла Мой суд, Встречи с бывшими друзьями" },
  { id: 468, title: "Из цикла Мой суд, Допросы свидетелей" },
  { id: 469, title: "Из цикла Мой суд, Допросы свидетелей-2" },
  { id: 470, title: "Из цикла Тюрьма, Возвращение" },
  { id: 471, title: "Из цикла Тюрьма, Вам!" },
  { id: 472, title: "Последний рыцарь" },
  { id: 473, title: "Парки ль лопотанье…" },
  { id: 474, title: "Только ведьмы да черти!.." },
  { id: 475, title: "Перечитывая Гоголя" },
  { id: 476, title: "Клеопатра" },
  { id: 477, title: "Наполеон" },
  { id: 478, title: "Цезарь" },
  { id: 479, title: "Лаокоон и сыновья…" },
  { id: 480, title: "Как Одиссей у Полифема" },
  { id: 481, title: "Все кончили скверно…" },
  { id: 482, title: "Декабристам" },
  { id: 483, title: "Людям" },
  { id: 484, title: "Стихи не пишутся…" },
  { id: 485, title: "Душа молчит или кричит…" },
  { id: 486, title: "Эпитафия поэтам" },
  { id: 487, title: "Кавалергарда век недолог…" },
  { id: 488, title: "Белой гвардии" },
  { id: 489, title: "Белое движенье" },
  { id: 490, title: "Гусары не бывают стары…" },
  { id: 491, title: "Мне мерещится ад…" },
  { id: 492, title: "Из цикла Страшный суд. Как призовут…" },
  { id: 493, title: "Из цикла Страшный суд. Слова — бред!.." },
  { id: 494, title: "Из цикла Страшный суд. Ада бездна — ужасна!.." },
  { id: 495, title: "Суд небесный" },
  { id: 496, title: "Суд земной" },
  { id: 497, title: "День Победы" },
  { id: 498, title: "Патриот ли я?" },
  { id: 499, title: "Вниз да вверх…" },
  { id: 500, title: "Любовь горит ещё, как фейерверк потешный…" },
  { id: 501, title: "Из цикла Тюрьма, Проходят люди, проходят судьбы…" },
  { id: 502, title: "Из цикла Тюрьма, Хочется порой умереть…" },
  { id: 503, title: "Из цикла Тюрьма, Жёнам заключённых" },
  { id: 504, title: "Из цикла Тюрьма, Письма" },
  { id: 505, title: "Из цикла Тюрьма, Автозэки, автозэки!.." },
  { id: 506, title: "Из цикла Тюрьма, Здесь уходят навек…" },
  { id: 507, title: "Из цикла Тюрьма, Почти три года…" },
  { id: 508, title: "Из цикла Тюрьма, Нас в сказку не звали!.." },
  { id: 509, title: "Из цикла Тюрьма, Здесь не люди, а спички…" },
  { id: 510, title: "Из цикла Тюрьма, Бутырка, Матроска!.." },
  { id: 511, title: "Из цикла Тюрьма, За тюремным столом…" },
  { id: 512, title: "Из цикла Тюрьма, Огни Матроски!.." },
  { id: 513, title: "Из цикла Тюрьма, Эх, тюрьма, тюрьма!.." },
  { id: 514, title: "Из цикла Тюрьма, Всё уж сказано-пересказано" },
  { id: 515, title: "Из цикла Тюрьма, От отчаянья…" },
  { id: 516, title: "Из цикла Тюрьма, Продолжается бред…" },
  { id: 517, title: "Из цикла Тюрьма, Эх, жёны, жёны у заключённых!.." },
  { id: 518, title: "Ассоль, Татьяна Ларина, Олеся…" },
  { id: 519, title: "Пошлость, пошлость заливает всё вокруг!.." },
  { id: 520, title: "Умереть! Раствориться во Вселенной!.." },
  { id: 521, title: "Через край — боль…" },
  { id: 522, title: "Умирать — рано…" },
  { id: 523, title: "Ночь, тишина…" },
  { id: 524, title: "Из цикла Библейские темы, Басенки" },
  { id: 525, title: "Из цикла Библейские темы, И Моисею…" },
  { id: 526, title: "Из цикла Библейские темы, Не укради…" },
  { id: 527, title: "Из цикла Библейские темы, Сыновья Адама-Евы…" },
  { id: 528, title: "Совращение" },
  { id: 529, title: "Ангел тянет ввысь…" },
  { id: 530, title: "Мне ангел в ухо бормочет глухо…" },
  { id: 531, title: "Две лягушки, две квакушки…" },
  { id: 532, title: "Укор ангелу-хранителю" },
  { id: 533, title: "Нет удач — хучь плачь!.." },
  { id: 534, title: "Проклятия Судьбе" },
  { id: 535, title: "Солнце всходит из-за туч…" },
  { id: 536, title: "Рассматривание фотографий с друзьями" },
  { id: 537, title: "Тюремные мечты" },
  { id: 538, title: "Мария в пушкинской Полтаве…" },
  { id: 539, title: "Из разговоров конвойных Чертановского суда" },
  { id: 540, title: "Рассказ алкоголика…" },
  { id: 541, title: "Объяснение следователю" },
  { id: 542, title: "Скучная история" },
  { id: 543, title: "Вчера и сегодня" },
  { id: 544, title: "Жёны героев" },
  { id: 545, title: "Гимн женщин" },
  { id: 546, title: "Нечисть" },
  { id: 547, title: "Русалка" },
  { id: 548, title: "Царевна-лягушка" },
  { id: 549, title: "Про сказки. У них и у нас" },
  { id: 550, title: "Мы все ленивы и слабы…" },  
  { id: 551, title: "Средь шумного бала, случайно…" },
  { id: 552, title: "Люблю! -ю! -ю! — проблеяла овца…" },
  { id: 553, title: "Девам" },
  { id: 554, title: "Борьба полов…" },
  { id: 555, title: "Вот странно баба — дура…" },
  { id: 556, title: "Умоляла любовь…" },
  { id: 557, title: "Есть мрак, есть свет…" },
  { id: 558, title: "Как-то летом, вечерком…" },
  { id: 559, title: "Распахнулись небеса…" },
  { id: 560, title: "Свет мой, зеркальце, скажи!.." },
  { id: 561, title: "Как-то полз себе по древу…" },
  { id: 562, title: "Современным писателям" },
  { id: 563, title: "Современным исполнителям" },
  { id: 564, title: "Объяснение со своим ангелом-хранителем и демоном-искусителем" },
  { id: 565, title: "Не Евгений Онегин (РОМАН В СТИХАХ)" },

];


const Gedichte: React.FC = () => (
  <div className="breadcrumbs">
    <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → <Link to="/schriftstellerei">Творчество</Link> → Мои стихи
    </div>
    <div className="content">
      <div className="content_white_cloud">
        <div className="cwc_top"></div>
        <div className="cwc_mid">
          <div className="content">
            <h2>Мои стихи</h2>
            <div style={{ backgroundColor: 'rgb(220, 220, 220)', textAlign: 'center' }}>
              <p>&nbsp;</p>
              <div style={{ backgroundColor: 'white', margin: '0 30px' }}>
                <div>&nbsp;</div>
                <div style={{ backgroundColor: 'rgb(243, 243, 243)', margin: '0 20px' }}>
                  {poems.map((poem) => (
                    <div key={poem.id}>
                      <strong>
                        <Link 
                          to={`/schriftstellerei/gedichte/gedicht${poem.id}`} 
                          className="yellow-underline2" 
                          style={{ fontSize: '20px' }}
                        >
                          {poem.title}
                        </Link>
                      </strong>
                      <div style={{ backgroundColor: 'rgb(255, 255, 255)' }}>&nbsp;</div>
                    </div>
                  ))}
                </div>
                <p>&nbsp;</p>
              </div>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
        <div className="cwc_bot"></div>
      </div>
    </div>
  </div>
);

export default Gedichte;
